import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject, Observable, distinctUntilChanged, takeUntil } from 'rxjs';
import { ICalenderEventModal } from 'src/app/core/domain/meetings.model';
import { IProfileDetails } from 'src/app/core/domain/profile.model';
import { MeetingService } from 'src/app/core/service/meeting.service';
import { getProfileData } from 'src/app/core/state/profile';
import { getGlobalSettings } from 'src/app/core/state/global';
import { IGlobalSettings } from 'src/app/core/domain/settings.model';
import { GlobalService } from 'src/app/core/service/global.service';
import 'add-to-calendar-button';
import { formatEnumStringForUI, formatEventTypeLabel } from '../../utils/common-methods';
import { ProfileService } from 'src/app/core/service/profile.service';
import { ToastAlertService } from '../../utils/toast.service';
import { LightGalleryAllSettings } from 'lightgallery/lg-settings';
import lgZoom from 'lightgallery/plugins/zoom';

@Component({
  selector: 'app-event-details-modal',
  templateUrl: './event-details-modal.component.html',
  styleUrls: ['./event-details-modal.component.scss']
})
export class EventDetailsModalComponent implements OnInit {
  globalSettings: IGlobalSettings;

  settings: Partial<LightGalleryAllSettings> = {
    counter: false,
    plugins: [lgZoom],
    licenseKey: 'GPLv3',
  };
  @Input() modalInst: NgbModalRef;

  @Input() modalData: {
    action: string;
    event: any;
  };

  @Input() isRescheduling = false;
  showChildComponent = false;
  attendingType="not_one_to_one";

  private destroyed$: Subject<void> = new Subject();
  public profileDetails$: Observable<IProfileDetails>;
  profileDetails: IProfileDetails;
  selectedResponse;
  eventUUID;
  eventQuestionsList;
  existingAttendenceForChild;
  constructor(
    private route: ActivatedRoute,
    private modal: NgbModal,
    private meetingService: MeetingService,
    private router: Router,
    private readonly store: Store,
    private uiLoader: NgxUiLoaderService,
    private globalService: GlobalService,
    private profileService: ProfileService,
    private toastService: ToastAlertService,
  ) { }

  ngOnInit(): void {
    this.eventUUID=this.modalData.event.uuid;

    if (this.modalData?.event?.checkIfResponseExists?.responseAction) {
      this.selectedResponse = { value: this.modalData.event?.checkIfResponseExists?.responseAction }
    }

    this.profileDetails$ = this.store.pipe(select(getProfileData));
    this.profileDetails$.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) { this.profileDetails = res; }
    })
    this.store.pipe(select(getGlobalSettings)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) {
        this.globalSettings = res;
      }
    })

    this.globalService.getEventQuestions(this.eventUUID).subscribe(
      (response: any) => {
        this.eventQuestionsList = response;
      })

  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.updateModalData();
  }

  get isInPast() {
    return moment(this.modalData?.event?.date).isBefore(moment()  , 'date');
  }

  /* Admin's "For stakeholders" Privacy Setting restricts an event to
     specific account types (allowedUserTypesToBook, populated from
     events.repository.ts's event-list queries). An empty/missing list
     means no restriction. This mirrors the authoritative check the
     backend now enforces in EventsService.attendEvent() -- this is UX
     only, to stop showing Apply to someone who'll be rejected anyway. */
  get isStakeholderTypeAllowed(): boolean {
    const allowedTypes = this.modalData?.event?.allowedUserTypesToBook;
    if (!Array.isArray(allowedTypes) || allowedTypes.length === 0) {
      return true;
    }
    return allowedTypes.includes(this.profileDetails?.accountType);
  }

  /* SAN-887: sibling admin restriction (allowedUsersProfileStatuses), same
     shape as isStakeholderTypeAllowed above. 'profile-approval-status' is
     set in localStorage by ProfileService on every completeness update --
     IProfileDetails itself doesn't carry approvalStatus. */
  get isProfileStatusAllowed(): boolean {
    const allowedStatuses = this.modalData?.event?.allowedUsersProfileStatuses;
    if (!Array.isArray(allowedStatuses) || allowedStatuses.length === 0) {
      return true;
    }
    return allowedStatuses.includes(localStorage.getItem('profile-approval-status'));
  }

  get meetingUrl() {
    const event: any = this.modalData.event
    if (event.meetingType === 'job-interview') {
      const link = this.router.serializeUrl(this.router.createUrlTree(['/job-interview/', event.uuid]));
      return window.location.origin + link;
    }
    // Hub/Spoke VideoSDK domain-whitelist gap: only the Hub's own domain can
    // ever be whitelisted with VideoSDK, so a spoke visitor's meeting link
    // must resolve to the Hub's own origin -- see MeetingService.getMeetingUrl().
    const link = this.router.serializeUrl(this.router.createUrlTree(['/meetings/meeting/' + event.uuid]));
    return this.meetingService.getMeetingUrl(link);
  }

  meetingDetail(event) {
    this.closeModal();
    if (event.meetingType === 'job-interview') {
      const link = this.router.serializeUrl(this.router.createUrlTree(['/job-interview/', event.uuid]));
      window.open(link, '_blank');
      return;
    }
    const link = this.router.serializeUrl(this.router.createUrlTree(['/meetings/meeting/' + event.uuid]));
    window.open(this.meetingService.getMeetingUrl(link), '_blank');
  }


  closeModal(): void {
    this.modalInst.close({});
  }

  tConvert(time, date) {
    return time;
  }

  get eventDate() {
    return new Date(this.modalData.event.date);
  }

  formatTo24Hour(timeAMPM) {
    const time24Hour = moment(timeAMPM, 'h:mm A').format('HH:mm');
    return time24Hour
  }

  updatedModalData;
  updateModalData(updatedmodalData: any) {
    this.updatedModalData= updatedmodalData.event?.checkIfResponseExists;
    if(updatedmodalData.event?.checkIfResponseExists){
    this.selectedResponse = { value: this.updatedModalData?.responseAction }
    }else{
     this.selectedResponse = { value: this.bookingResponse.responseAction }
    }
 }

  updateExistingAttendence(eventData: any): void {
    this.bookingResponse = eventData;
  }

  get existingAttendence() {
    return this.updatedModalData || this.bookingResponse || this.modalData?.event?.checkIfResponseExists;
  }

  bookingResponse;
  async selectResponse(item) {
    const event: any = this.modalData.event;

    this.selectedResponse = item;
    const existingAttendence = this.bookingResponse || event.checkIfResponseExists;

    if (item.value == 'attending' && this.eventQuestionsList.length) {
      this.showChildComponent = item.value == 'attending' ? true : false;
      this.existingAttendenceForChild = { existingAttendence: existingAttendence, value: item.value, event: event ,modalData:this.modalData};
    } else {
      // SAN-1032: a rejected attend/update call (e.g. 409 "already
      // registered") was awaited with no catch and surfaced as an
      // "Uncaught (in promise)" error — show the backend message instead.
      try {
        if (existingAttendence?.uuid) {
          const res = await this.globalService.updateWebinarEventBooking(event.uuid, existingAttendence?.uuid, item.value).toPromise();
          if (res) {
            this.bookingResponse = res;
          }

          if (this.modalData?.event?.checkIfResponseExists) {
            this.modalData.event.checkIfResponseExists.responseAction = item.value;
          }else{
            existingAttendence.responseAction= item.value
          }
        } else {
          this.bookingResponse = await this.globalService.bookEventSlot(event.uuid, null, null, item.value, null, null, "You have successfully registered for the event").toPromise();
        }
      } catch (fault) {
        this.selectedResponse = existingAttendence?.responseAction ? { value: existingAttendence.responseAction } : undefined;
        if (fault?.status !== 401 && fault?.status !== 403) {
          this.toastService.showToast(fault?.error?.message || 'Unable to update your response. Please try again.', 'error');
        }
      }
    }

  }

  // async selectResponse(item) {
  //   const event: any = this.modalData.event

  //   this.selectedResponse = item;
  //   const existingAttendence = this.bookingResponse || event.checkIfResponseExists
  //   if(existingAttendence?.uuid) {
  //     const res = await this.globalService.updateWebinarEventBooking(event.uuid, existingAttendence?.uuid, item.value).toPromise()
  //     if(res) {
  //       this.bookingResponse = res
  //     }

  //     if(this.modalData?.event?.checkIfResponseExists) {
  //       this.modalData.event.checkIfResponseExists.responseAction = item.value
  //     }
  //   }else{
  //     this.bookingResponse = await this.globalService.bookEventSlot(event.uuid, null, null, item.value, null, null, "You have successfully registered for the event").toPromise()
  //   }
  //   // this.globalService.eventResponse(event.id, item.value).subscribe();
  // }


  get speakerProfileLink() {
    if (this.modalData?.event?.speakerCompanyDetails) {
      return this.profileService.getProfileLink(
        this.modalData?.event?.speakerCompanyDetails?.uuid,
        this.modalData?.event?.speakerCompanyDetails?.name,
        this.modalData?.event?.speakerDetails?.accountType
      )
    }
    return ''
  }

  formatEnumStringForUI(i) {
    return formatEnumStringForUI(i)
  }

  formatEventTypeLabel(eventType) {
    return formatEventTypeLabel(eventType)
  }
  get mainSpeaker(){
    const speaker = this.modalData.event?.speakerDetails;
    const speakerCompanyDetails = this.modalData.event?.speakerCompanyDetails;
    if (!speaker) {
      return {}
    }
    return {
        "bio": this.modalData.event.speakerBio,
        "name": speaker?.name,
        "email": "",
        "mobile": null,
        "imageKey": null,
        "linkedin":this.modalData.event.speakerLinkedin,
        "existingImage": speakerCompanyDetails?.logo || speaker.avatar,
        "speaker_image": speakerCompanyDetails?.logo || speaker.avatar,

    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }


  handleMainSpeakerClick() {
    const link = this.profileService.getProfileLink(this.modalData.event.speakerCompanyDetails.uuid, this.modalData.event.speakerCompanyDetails.name, this.modalData.event.speakerDetails.accountType)
    this.router.navigateByUrl(link)
    this.closeModal()
  }

  closeChild() {
    this.selectedResponse = { value: this.modalData.event?.checkIfResponseExists?.responseAction || this.bookingResponse?.responseAction }
    this.showChildComponent = false;
  }

}
